import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-9f356cf6"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "wrapper__details" }

import CharacterInfo from '@/components/Character/CharacterInfo.vue';
import BaseSpinner from '@/components/UI/BaseSpinner.vue';
import NotFound from '@/views/NotFound.vue';
import { computed } from 'vue';
import { useStore } from 'vuex';
import { useRoute } from 'vue-router';

export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const route = useRoute();
const store = useStore();

const character = computed(() => store.state.charactersModule.currentCharacter);
const loading = computed(() => store.state.charactersModule.isLoading);
const error = computed(() => store.state.charactersModule.error);
store.dispatch('fetchCurrentCharacter', route.params.id);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_unref(error) && !_unref(loading))
      ? (_openBlock(), _createBlock(NotFound, { key: 0 }))
      : (!_unref(character) && _unref(loading) && !_unref(error))
        ? (_openBlock(), _createBlock(BaseSpinner, { key: 1 }))
        : (_openBlock(), _createBlock(CharacterInfo, {
            key: 2,
            character: _unref(character)
          }, null, 8, ["character"]))
  ]))
}
}

})